import { TransferListData } from "@mantine/core";
import { useEffect, useState } from "react";
import {
  INITIAL_ENTITY,
  useRoleUsersQuery,
  useUserEntityQuery,
} from "services/api";

const useUserTransferList = (roleNo: string) => {
  const [userTransferList, setUserTransferList] = useState<TransferListData>([
    [],
    [],
  ]);

  const { data: roleUsers, isLoading: isLoadingRoleUsers } =
    useRoleUsersQuery(roleNo);

  const { data: userEntity = INITIAL_ENTITY, isLoading: isLoadingUserEntity } =
    useUserEntityQuery();

  useEffect(() => {
    if (Array.isArray(roleUsers) && userEntity.ids.length > 0) {
      const remainList = userEntity.ids.filter((x) => !roleUsers.includes(x));

      setUserTransferList([
        roleUsers.map((x) => userEntity.entities[x]),
        remainList.map((x) => userEntity.entities[x]),
      ]);
    }
  }, [roleUsers, userEntity]);

  return [
    userTransferList,
    setUserTransferList,
    isLoadingRoleUsers || isLoadingUserEntity,
  ] as const;
};

export default useUserTransferList;
